<template>
  <NuxtLayout>
    <NuxtPage />
    <CustomSnackbar />
  </NuxtLayout>
</template>

<script setup lang="ts">
import CustomSnackbar from './components/common/layout/CustomSnackbar.vue';
import type { SnackbarMessage } from '~/types';

const { message, type } = storeToRefs(useSnackbarStore());
const { add } = useSnackbar();

onMounted(() => {
  nextTick(() => {
    if (message.value) {
      add({
        type: type.value,
        message: message.value
      } as SnackbarMessage);
    }
  });
});

watch(message, (newMessage) => {
  nextTick(() => {
    if (newMessage) {
      add({
        type: type.value,
        message: message.value
      } as SnackbarMessage);
    }
  });
});
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
.vue3-snackbar-message-content {
  width: auto;
  font-size: 12px;
  max-width: 600px;
}
</style>
